import * as React from 'react';
import * as styles from './menu.module.scss';
import { Category, Dashboard } from '@material-ui/icons';
import { NavLink } from 'react-router-dom';
import Paths from '../../models/enums/paths';
import clsx from 'clsx';
import { useClients } from '../../hooks/useClients';
import { AppContext } from '../../shared/app-context';
import useUser from '../../hooks/useUser';
import SegmentationPermission from '../../models/enums/segmentationPermission';

interface Props {
  collapsed: boolean;
}

const Menu = ({ collapsed }: Props) => {
  const { state } = React.useContext(AppContext);
  const clientsQuery = useClients();
  const { getCurrentUser } = useUser();
  const [userSegmentationAccess, setUserSegmentationAccess] = React.useState<boolean>(false);

  React.useEffect(() => {
    void checkUser();
  }, [state.clientId, clientsQuery.data]);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      const assignedSegmentation = currentUser.assignedSegmentation.find(
        (as) => as.clientId === state.clientId
      );
      setUserSegmentationAccess(assignedSegmentation?.segmentationPermission !== SegmentationPermission.None);
    } catch (error) {
      setUserSegmentationAccess(false);
    }
  };

  const currentClient = React.useMemo(() => {
    if (clientsQuery.data && state.clientId) {
      return clientsQuery.data.results.find(client => client.clientId === state.clientId);
    }
  }, [state.clientId, clientsQuery.data]);

  return (
    <nav>
      <ul className={styles.menu}>
        <li>
          <NavLink to={Paths.Reports} className={isActive => clsx(styles.menuItem, isActive && styles.active)}>
            <Dashboard className={styles.menuItemIcon} />
            <span className={clsx(styles.menuItemLabel, collapsed && 'sr-hidden')}>Dashboards</span>
          </NavLink>
        </li>
        {currentClient?.enableSegmentation && userSegmentationAccess && (
          <li>
            <NavLink to={Paths.Segments} className={isActive => clsx(styles.menuItem, isActive && styles.active)}>
              <Category className={styles.menuItemIcon} />
              <span className={clsx(styles.menuItemLabel, collapsed && 'sr-hidden')}>Segments</span>
            </NavLink>
          </li>
        )}
      </ul>
    </nav>
  );
};
export default Menu;
